import moment from 'moment';
import { upperCase } from 'lodash';
import 'moment/locale/id';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const HeaderCalendar = ({ date }) => {
  const { i18n } = useTranslation();
  const dateNumber = moment(date?.date)?.locale(i18n.language)?.format('DD');
  const dayName = moment(date?.date)?.locale(i18n.language)?.format('ddd');

  return (
    <Box>
      <TextBold className={styles['date-number__text']}>{dateNumber}</TextBold>
      <TextRegular className={styles['day-name__text']}>{upperCase(dayName)}</TextRegular>
    </Box>
  );
};

export default HeaderCalendar;
